export default __webpack_public_path__ + "static/media/natif.7eda3c4b.svg";